import { SelectedAddOn } from '@acorn-portal/shared/src/services/renewalsApi';

import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import useUpdateAddons from './useUpdateAddons';

const filterOutAddon = (addons: SelectedAddOn[], targetId: string) => {
	return addons.filter((addon) => addon.underwrittenDataPointId !== targetId);
};

export default function useAddonActions() {
	const renewalStore = useAppSelector((redux) => redux.renewal);
	const { onUpdateAddons, isAddOnLoading } = useUpdateAddons(renewalStore);

	const getCurrentSelectedAddons = () => {
		return (
			renewalStore.renewalRatingResponse?.addOns
				?.filter((addon) => addon.selected)
				?.map((addon) => ({
					underwrittenDataPointId: addon.underwrittenDataPointId,
					addOnCode: addon.addOnCode,
				})) || []
		);
	};

	const onAddSingleAddOn = async (selectedAddOns: SelectedAddOn[]) => {
		const tempAddons = [...getCurrentSelectedAddons(), selectedAddOns[0]];
		await onUpdateAddons(tempAddons);
	};

	const onReplaceAddon = async (selectedAddOns: SelectedAddOn[]) => {
		await onUpdateAddons(selectedAddOns);
	};

	const onRemoveAddon = async (underwrittenDataPointId: string) => {
		const currentSelectedAddons = getCurrentSelectedAddons();

		const filteredAddons = filterOutAddon(currentSelectedAddons, underwrittenDataPointId);

		await onUpdateAddons(filteredAddons);
	};

	return { onAddSingleAddOn, onRemoveAddon, onReplaceAddon, isAddOnLoading };
}
